import { RouterEffects } from './router.effects';

export const effects: Array<any> = [RouterEffects];

export * from './router.effects';
